<template>
    <div class="flex flex-full flex-column align-center justify-center bg-white register">
        <div class="padding-lr-xl padding-bottom-xl margin-bottom-xl" style="width:100%;box-sizing: border-box">
            <div class="text-xsl text-black text-bold text-center padding-bottom-xl">注册</div>
            <van-cell-group>
                <van-field v-model="formData.mobile" type="number" size="large" error-message="" placeholder="请输入手机号" maxlength="11"  clearable></van-field>
                <van-field v-model="formData.verifyCode" type="number" size="large" error-message="" placeholder="请输入短信验证码" maxlength="6"  clearable >
                    <van-button slot="button" size="small" type="primary" plain
                            @click="sendVerifyCode" :disabled="verifyCode.disabled" :loading="verifyCode.loading" loading-text="发送中">
                        {{verifyCode.info+(verifyCode.count?"("+verifyCode.count+"s)":"")}}
                    </van-button>
                </van-field>
                <van-field v-model="formData.password" type="password" size="large" maxlength="32" placeholder="请输入密码" clearable></van-field>
            </van-cell-group>

            <div class="padding-top padding-bottom-xl">
                <van-button  size="large" type="primary" round @click="formSubmit">确定</van-button>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import { Field ,CellGroup, Button, Checkbox } from 'vant';
  import { util } from '@/libs/util'
  import { sendVerifyCode, register } from '@/api/account'

  Vue.use(Field)
    .use(CellGroup)
    .use(Button)
    .use(Checkbox)

  let timer;
  export default {
    name: "register",
    data(){
      return{
        formData:{
          mobile: null,
          verifyCode: null,
          password: null,
          wxOpenId: this.$route.query.wxOpenId,
          ddUserId: this.$route.query.ddUserId
        },
        verifyCode:{
          disable:false,
          loading:false,
          info:"发送验证码",
          count:0
        }
      }
    },
    methods:{
      sendVerifyCode(){
        const mobile = this.formData.mobile
        if(!mobile){
          return util.showTips("请输入手机号码")
        }
        if (!/^[1][0-9]{10}$/.test(mobile)) {
          return util.showTips("手机号格式错误")
        }
        let that = this
        this.verifyCode.disabled=true
        this.verifyCode.loading=true
        // 发送中
        sendVerifyCode(mobile).then(res => {
          that.verifyCode.loading=false
          const data = res.data
          if (data.code == 0) {
            that.verifyCode.count=60
            that.verifyCode.info="已发送"
            timer = setInterval(function(){
              that.verifyCode.count--
              if(that.verifyCode.count==0){
                clearInterval(timer)
                that.verifyCode.disabled=false
                that.verifyCode.info="重新发送"
              }
            },1000)
          } else {
            util.showModal("发送失败",data.msg)
            that.verifyCode.disabled=false
            that.verifyCode.info="重新发送"
          }
        })
      },
      formSubmit() {
        let vm = this
        const mobile = this.formData.mobile
        const verifyCode = this.formData.verifyCode
        const password = this.formData.password

        if (mobile == null || mobile == '') {
          return util.showTips('请输入手机号')
        }
        if (!/^[1][0-9]{10}$/.test(mobile)) {
          return util.showTips("手机号格式错误")
        }

        if (verifyCode == null || verifyCode == '') {
          return util.showTips('请输入验证码')
        }

        if (password == null || password == '') {
          return util.showTips('请输入密码')
        }
        if (password.length < 6) {
          return util.showTips('密码不能小于6位')
        }
        if (password.length > 32) {
          return util.showTips('密码不能大于32位')
        }

        // 登录
        util.showLoading('请稍候')
        register(
          mobile,
          verifyCode,
          password,
          this.formData.wxOpenId,
          this.formData.ddUserId
        ).then(res => {
          util.hideLoading();
          const data = res.data
          if (data.code == 0) {
            util.showSuccessTips("注册成功")
            timer = setTimeout(function(){
              vm.$router.replace('/set-token?token='+ data.token)
              clearTimeout(timer)
            },1000)
          } else {
            util.showModal("注册失败",data.msg)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .register{
        .van-cell{
            padding:10px 0;
            input{
                box-shadow: 0 0 20px 20px #fff inset
            }
        }
        .van-cell:not(:last-child)::after{
            left:0 !important;
        }
    }

</style>
